import { render, staticRenderFns } from "./TwilightBarChart.vue?vue&type=template&id=98b5cfa0"
import script from "./TwilightBarChart.vue?vue&type=script&lang=js"
export * from "./TwilightBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports